import React from "react";
import { Modal, Button, Space } from "antd";

interface IModalProps {
  show: boolean;
  showModal: Function;
  handleLapse?: Function | undefined;
  handlePremium?: Function;
  memberId: any;
}

const LoadPremiumModal: React.FC<IModalProps> = ({
  show,
  showModal,
  handlePremium,
  memberId,
}) => {
  const handleConfirm = async () => {
    if (handlePremium) {
      await handlePremium(memberId, {});
    }
    showModal();
  };

  const handleCancel = () => {
    showModal();
  };

  return (
    <Modal
      title="Load Premium"
      open={show}
      onCancel={handleCancel}
      width={500}
      footer={null}
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <h3>Are you sure you want to load this premium?</h3>

        <Space style={{ marginTop: 20 }}>
          <Button size="large" onClick={handleCancel}>
            No
          </Button>
          <Button size="large" type="primary" onClick={handleConfirm}>
            Yes
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default LoadPremiumModal;
